import { postRequest } from "../config/axiosConfig";
import { ITlsCheckRequest } from "../interfaces/ITlsCheck";

class TlsCheckService {
  async checkTls(body: ITlsCheckRequest) {
    return await postRequest("email/tlsCheck", body);
  }
}

export default TlsCheckService;
